// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "common" : chunkId) + "-legacy." + {"76":"ad8250ac","959":"300c0927"}[chunkId] + ".js";
};